<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">
    Mensageria
    </div>
</div>
  <div>
  @if (checkPermission('criar')) {
    <div class="flex w-full flex-row justify-end items-end">
      <button mat-raised-button class="btn-add" (click)="newDriver()">
        Novo
      </button>
    </div>
  }

<div>
  <div class="mt-4">
    @if (checkPermission('visualizar')) {
      <div class="w-full gap-2 flex items-center justify-between">
        <div class="w-5/12 mb-3 flex items-center gap-4" [formGroup]="form">
        <mat-form-field class="input-tg w-8/12 mt-message-input search-tg" appearance="outline">
          <mat-label>Tipo de Uso</mat-label>
          <mat-select formControlName="tipo_uso" (selectionChange)="onChange()">
            @for (item of listUseTypes; track item.value) {
              <mat-option [value]="item.id">{{ item.nome + ' - ' + item.descricao}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        </div>
        <form-search [search]="inputSearch" class="w-full flex justify-end" (responseSearch)="search($event)" />
      </div>
    }
    <div>
      @if (!loading) {
        <div>
          <table-list-simple
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="editItem($event)"
            (deleteItem)="deleteItem($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
  </div>
